var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4973_1801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6453 5.67633C18.0859 5.23585 18.3334 4.63839 18.3335 4.01538C18.3336 3.39237 18.0862 2.79484 17.6457 2.35425C17.2052 1.91366 16.6077 1.66609 15.9847 1.66602C15.3617 1.66594 14.7642 1.91335 14.3236 2.35383L3.20194 13.478C3.00845 13.6709 2.86537 13.9084 2.78527 14.1697L1.68444 17.7963C1.6629 17.8684 1.66127 17.945 1.67973 18.0179C1.69819 18.0908 1.73604 18.1574 1.78927 18.2105C1.8425 18.2636 1.90912 18.3014 1.98207 18.3197C2.05502 18.3381 2.13157 18.3363 2.2036 18.3147L5.8311 17.2147C6.09208 17.1353 6.32958 16.9931 6.52277 16.8005L17.6453 5.67633Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.16699L15.8333 7.50033",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4973_1801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.f6c1a5713e663fa50ebdce9e65f8f2fc.svg";
export { ForwardRef as ReactComponent };